import api from "@/data/api";
import { GenericMultiSelect } from "./GenericMultiSelect";

export function TagsDropdown({ value, onChange }) {
  return (
    <GenericMultiSelect
      sectionLabel="Tags"
      inputLabel="Search & select tags"
      selectedValues={value.map((tag) => ({ name: tag }))}
      onSelectionChange={(items) => onChange(items.map((item) => item.name))}
      fetchOptions={async (query) => {
        const res = await api.searchTags(query);
        return (res?.data || [])
          .map((tag) => (tag?.name ? { name: tag.name } : null))
          .filter(Boolean);
      }}
      getOptionLabel={(option) => option.name}
      compareOptions={(a, b) => a.name === b.name}
      debounceDelay={350}
      clearOptionsOnEmptyQuery={false}
      sx={{ mb: 2 }}
    />
  );
}